import { useState } from "react";

import ToastUtils from "./toast-utils";

export enum CustomToastEnum {
  Toast,
  View,
}

export const useCustomToast = (type: CustomToastEnum) => {
  const [errorMessage, setErrorMessage] = useState<string>("");

  const renderError = (): React.ReactNode => {
    if (type == CustomToastEnum.View) {
      return (
        <div className="error-message" style={{ paddingLeft: "5px" }}>
          {errorMessage}
        </div>
      );
    } else {
      return <></>;
    }
    return null;
  };

  const showErrorToast = (message: string) => {
    if (type == CustomToastEnum.Toast) {
      ToastUtils.showErrorToast(message);
    } else if (type == CustomToastEnum.View) {
      setErrorMessage(message);
      setTimeout(() => {
        setErrorMessage("");
      }, 4000);
    }
  };

  return { renderError, showErrorToast };
};
